import React, { useEffect, useState } from 'react';
import logo from '../../White.png';
import './legal.scss';

const STORAGE_KEY = 'ciceron-legal-lang';

export function useLegalLang() {
    const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || 'en');
    return [lang, setLang];
}

export default function LegalLayout({ children, lang, setLang, title }) {
    useEffect(() => {
        document.title = title ? `${title} | Ciceron` : 'Ciceron';
        return () => {
            document.title = 'Ciceron';
        };
    }, [title]);

    const changeLang = (next) => {
        localStorage.setItem(STORAGE_KEY, next);
        setLang(next);
    };

    return (
        <div className="legal-page">
            <header className="legal-header">
                <div className="legal-header-inner">
                    <div className="legal-brand">
                        <img src={logo} alt="Ciceron" />
                    </div>
                    <h1 className="legal-header-title">{title}</h1>
                    <div className="legal-lang" role="group" aria-label="Language">
                        <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => changeLang('en')}>EN</button>
                        <button type="button" className={lang === 'sq' ? 'active' : ''} onClick={() => changeLang('sq')}>SQ</button>
                    </div>
                </div>
            </header>
            <div className="legal-wrap">
                <main className="legal-card">{children}</main>
                <footer className="legal-footer">© {new Date().getFullYear()} Ciceron</footer>
            </div>
        </div>
    );
}
